import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/chi-sono", label: "Chi sono" },
  { to: "/coaching", label: "Coaching" },
  { to: "/pacchetti", label: "Pacchetti" },
  { to: "/contatti", label: "Contatti" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 border-b border-line/60 bg-ink/70 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-12">
          <Link to="/" data-testid="nav-logo" className="font-display text-lg tracking-wide text-ivory">
            MARTINA SERRA
            <span className="ml-2 hidden text-[10px] uppercase tracking-[0.3em] text-mist sm:inline">
              Training &amp; Coaching
            </span>
          </Link>
          <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                className={({ isActive }) =>
                  `label-caps transition-colors duration-300 ${
                    isActive ? "text-mist" : "text-ivory/70 hover:text-ivory"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/pacchetti" data-testid="nav-cta" className="btn-primary !px-6 !py-3">
              Inizia ora
            </Link>
          </nav>
          <button
            data-testid="nav-menu-button"
            onClick={() => setOpen(!open)}
            className="text-ivory lg:hidden"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </header>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-40 flex flex-col justify-center bg-ink/95 px-8 backdrop-blur-xl lg:hidden"
            data-testid="nav-mobile-menu"
          >
            {LINKS.map((l, i) => (
              <motion.div
                key={l.to}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.05 * i, duration: 0.5 }}
              >
                <NavLink
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${l.label.toLowerCase().replace(" ", "-")}`}
                  className={`block border-b border-line py-5 font-display text-3xl ${
                    location.pathname === l.to ? "text-mist" : "text-ivory"
                  }`}
                >
                  {l.label}
                </NavLink>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
